import key_map_img from "../../../../assets/images/keyless-return/map-guerin-shadow.svg";
import React from "react";

export default function ParkDirections({t}) {
  return (<div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <img
      src={key_map_img}
      alt="Key Dropoff"
      style={{
        maxWidth: "100%", marginBottom: "3rem",
      }}
    />

    <p style={{fontSize: "1.4rem", marginTop: "3rem"}}>
      {t("keylessReturnParkDirections")}
    </p>
  </div>)
}
